<template>
  <div class="contract-body">

    <!-- 搜索 -->
    <div class="search-wrap" >
      <div class="opt-wrap">
        <el-button size="mini" type="primary" v-if="ERP.isPermission(26005001001001)" @click="editBusiness()" icon="el-icon-plus">添加类型</el-button>
      </div>
      <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
      <el-button size="mini" type="primary" @click="getBusinessList()" :loading="searchLoading">搜索</el-button>
    </div>

    <!-- 数据列表 -->
    <div class="table-wrap" >
      <el-table v-loading="searchLoading" :data="tableData">
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column prop="name" label="类型名称" align="center"></el-table-column>
        <el-table-column prop="code" label="类型简称" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" v-if="ERP.isPermission(26005001001002)" size="mini" icon="el-icon-edit" @click="editBusiness(scope.row)">编辑</el-button>
<!--            <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteBusiness(scope.row)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 添加窗口 -->
    <el-dialog title="添加业务类型" :visible.sync="dialogVisible" :close-on-click-modal="true" class="business-dialog" width="400px">

      <el-form ref="form" :rules="rules" :model="form" label-width="100px" size="mini" class="business-form">
        <el-form-item label="类型名称" prop="name">
          <el-input v-model="form.name" placeholder="请填写类型名称"></el-input>
        </el-form-item>
        <el-form-item label="类型简称" prop="name">
          <el-input v-model="form.code" placeholder="请填写类型简称"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit()" :loading="submitLoading">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

  import { Business } from './common.js'
  import CommonHelp from "./common/CommonHelp";

export default {
  name:"ContractBusiness",
  data () {
    return {
      total: 0,
      tableData: [],
      keyword: '',
      page: 1,
      page_size: 15,
      searchLoading: false,
      dialogVisible: false,
      submitLoading: false,
      form: {},
      defValue: {
        id: '',
        name: '',
        code:''
      },
      rules: {
        name: [
          { required: true, message: '请输入类型名称。', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入类型简称。', trigger: 'blur' },
        ],
      },
    }
  },
  beforeMount() {
    this.form = this.getFormData()
  },
  watch: {
    "form.name":function (n) {
      this.form.code=CommonHelp.getPinyinFast(n)
    }

  },
  mounted() {
    this.getBusinessList()
  },
  methods: {

    getFormData(data) {
      return Object.assign({}, this.defValue, data)
    },

    editBusiness(data) {
      this.form = this.getFormData(data)
      this.dialogVisible = true
    },

    deleteBusiness(data) {

      this.$confirm(`此操作将删除 [ ${data.name} ]，是否继续?`, '提示', {type: 'warning'}).then(() => {
        Business.deleteBusiness({id: data.id}, res => {
          this.message(res)
          if(res.code == 0) this.getBusinessList()
        })
      })

    },

    submit() {

      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.saveArea()
        } else {
          return false;
        }
      });

    },

    saveArea() {

      this.submitLoading = true
      let data = Object.assign({}, this.form)
      Business.saveBusiness(data, res => {
        this.submitLoading = false
        this.message(res)
        if(res.code == 0) {
          this.dialogVisible = false
          this.getBusinessList()
        }
      })

    },

    getBusinessList() {

      let data = {keyword: this.keyword, page: this.page, page_size: this.page_size}
      Business.getBusinessList(data, res => {
        if(res.code == 0) {
          this.total = res.data.total
          this.tableData = res.data.list
        }
      })

    },

    message(res) {
      this.$message({type: res.code == 0 ? 'success' : 'error', message: res.msg})
    },

    // methods end
  }
}
</script>
<style lang="scss" scoped>

@import './common2.scss';

.business-form {
  margin-right: 50px;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/Business.vue